<template>
    <div :class="[wrapperClass,'d-flex g-25 flex-column']">
        <div :class="[itemClass, i == current ? lastItemClass : null,'d-flex align-items-center py-50 px-75 rounded',i == current && done != true  ? 'text-primary bg-light-primary' : 'bg-light']" v-for="i in current">
            <span :class="i == current && done != true ? 'font-weight-bolder':null">{{ texts[i - 1] }}</span>
            <b-spinner class="ml-auto" v-if="i == current && done != true" small></b-spinner>
            <feather-icon icon="CheckCircleIcon" class="ml-auto text-success" v-if="i != current || done == true"></feather-icon>
        </div>
    </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue';

export default {
    components:{
        BSpinner
    },
    props:{
        texts:{
            type:Array,
            default:()=>[]
        },
        duration:{
            type:Number,
            default:1000
        },
        itemClass:{
            type:String,
            default:''
        },
        lastItemClass:{
            type:String,
            default:''
        },
        wrapperClass:{
            type:String,
            default:''
        },
        done:{
            type:Boolean,
            default: false
        }
    },
    data: function() {
        return {
            text: "",
            current:0,
            interval:null
        };
    },
    methods: {
        updateWord() {
            if(this.current <= this.texts.length - 1) {
                this.current = this.current + 1
            } else if(this.current == this.texts.length){
                clearInterval(this.interval)
            }
        }
    },
    mounted: function() {
        this.updateWord()
        this.interval = setInterval(this.updateWord, this.duration)
    }
};
</script>